export default "__VITE_ASSET__BEV4tZB7__"